import { render, staticRenderFns } from "./empty-demo.vue?vue&type=template&id=4c1ef27d&scoped=true"
import script from "./empty-demo.vue?vue&type=script&lang=js"
export * from "./empty-demo.vue?vue&type=script&lang=js"
import style0 from "./empty-demo.vue?vue&type=style&index=0&id=4c1ef27d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ef27d",
  null
  
)

export default component.exports